module.exports = __webpack_public_path__ + "static/media/CheckCircle.e195f014.svg";